
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/club-trip",
      function () {
        return require("private-next-pages/personal/club-trip/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/club-trip"])
      });
    }
  